import { render, staticRenderFns } from "./TransactionContentSet.vue?vue&type=template&id=59981335&"
import script from "./TransactionContentSet.vue?vue&type=script&lang=ts&"
export * from "./TransactionContentSet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports